<template>
  <b-form id="coordinate-search-form">
    <b-alert variant="danger" :show="coordinateSearchHasError"><strong>Uwaga.</strong> Formularz zawiera błędy.</b-alert>
    <b-form-group label="Układ współrzędnych" label-for="coordinate-system-select">
      <small class="text-danger" v-show="coordinateSearchErrors.coordinateSystemNotSelected">Należy wybrać układ współrzędnych.</small>
      <b-form-select id="coordinate-system-select" v-model="selectedCoordinateSystem" :class="{ 'is-invalid': coordinateSearchErrors.coordinateSystemNotSelected, 'form-control': true }">
        <option value="" disabled>Wybierz</option>
        <option v-for="system in coordinateSystems"
            :key="system.epsg"
            :value="system.epsg">
            {{system.name}}
        </option>
      </b-form-select>
    </b-form-group>
    <b-form-group label="X" label-for="coordinate-x-input">
      <small class="text-danger" v-show="coordinateSearchErrors.coordinateXIsEmpty">Należy podać współrzędną X.</small>
      <b-form-input id="coordinate-x-input" placeholder="Wpisz" v-model="coordinateX" :class="{ 'is-invalid': coordinateSearchErrors.coordinateXIsEmpty, 'form-control': true }"></b-form-input>
    </b-form-group>
    <b-form-group label="Y" label-for="coordinate-y-input">
      <small class="text-danger" v-show="coordinateSearchErrors.coordinateYIsEmpty">Należy podać współrzędną Y.</small>
      <b-form-input id="coordinate-y-input" placeholder="Wpisz" v-model="coordinateY" :class="{ 'is-invalid': coordinateSearchErrors.coordinateYIsEmpty, 'form-control': true }"></b-form-input>
    </b-form-group>
    <b-form-group label="Tolerancja" label-for="coordinate-tolerance-input">
      <small class="text-danger" v-show="coordinateSearchErrors.coordinateToleranceIsInvalid">Wpisana wartość jest niepoprawna.</small>
      <small class="text-danger" v-show="coordinateSearchErrors.coordinateToleranceIsEmpty">Należy podać tolerancję.</small>
      <b-form-input id="coordinate-tolerance-input" placeholder="Wpisz" min="1" max="5000" v-model="coordinateTolerance" :class="{ 'is-invalid': coordinateSearchErrors.coordinateToleranceIsInvalid || coordinateSearchErrors.coordinateToleranceIsEmpty, 'form-control': true }"></b-form-input>
    </b-form-group>
    <b-form-group>
      <b-btn @click="submitCoordinateSearch()" variant="primary" class="col-md-12" size="sm">
        <span>Szukaj</span>
      </b-btn>
    </b-form-group>
  </b-form>
</template>

<script>
import { CoordinateSystems } from "../../common/mapEnums";
import {
  SEARCH_COORDINATE_GET
} from '../../store/actions.type';
export default {
  name: "CoordinateSearch",
  data() {
    return {
      coordinateSearchErrors: {
        coordinateSystemNotSelected: false,
        coordinateXIsEmpty: false,
        coordinateYIsEmpty: false,
        coordinateToleranceIsEmpty: false,
        coordinateToleranceIsInvalid: false
      },
      coordinateSystems: CoordinateSystems,
      selectedCoordinateSystem: "",
      coordinateX: "",
      coordinateY: "",
      coordinateTolerance: 1,
    }
  },
  methods: {
    submitCoordinateSearch() {
      if(this.isValid()) {
        this.submit();
      }
    },
    isValid() {
      this.coordinateSearchErrors.coordinateSystemNotSelected = !this.selectedCoordinateSystem;
      this.coordinateSearchErrors.coordinateXIsEmpty = !this.coordinateX;
      this.coordinateSearchErrors.coordinateYIsEmpty = !this.coordinateY;
      this.coordinateSearchErrors.coordinateToleranceIsEmpty = !this.coordinateTolerance;
      this.coordinateSearchErrors.coordinateToleranceIsInvalid = this.coordinateTolerance < 1 || this.coordinateTolerance > 5000;

      if(this.coordinateSearchHasError)
        return false;
      return true;
    },
    submit() {
      var activeLayer = this.$store.getters.featuresLayer;
      if(activeLayer) {
        this.$store.dispatch(SEARCH_COORDINATE_GET, { coordinateSystem: this.selectedCoordinateSystem, 
          X: this.coordinateX, Y: this.coordinateY, tolerance: this.coordinateTolerance, activeLayerId: activeLayer.id });
      } else {
        this.$notify({
          type: 'error',
          title: 'Uwaga!',
          text: 'Wyszukiwanie nieudane. Do wyszukiwania za pomocą współrzędnych niezbędna jest warstwa aktywna.',
          duration: 2000,
        });
      }


    }
  },
  computed: {
    coordinateSearchHasError() {
      return this.coordinateSearchErrors.coordinateSystemNotSelected ||
             this.coordinateSearchErrors.coordinateXIsEmpty ||
             this.coordinateSearchErrors.coordinateYIsEmpty ||
             this.coordinateSearchErrors.coordinateToleranceIsEmpty ||
             this.coordinateSearchErrors.coordinateToleranceIsInvalid;
    }
  }
}
</script>

<style>

</style>
